export type FileType = {
  uri: string | ArrayBuffer | null | undefined;
  type: 'image' | 'document';
};

export type UploadFileType = {
  file: File;
  uploadPercent: number;
};

export enum DropzoneStateEnums {
  IDLE = 'idle',
  UPLOAD = 'uploading',
  SUCCESS = 'upload-success',
}

export interface ICommonFileInput {
  className?: string;
  accept?: string;
  acceptText?: string;
  disabled?: boolean;
}
